"use strict";
/**
 * Material Admin/Moderation API Response Types
 *
 * Types for moderation, admin, and material management endpoints
 * in lambda-secure that don't have frontend fetchers.
 * These are admin-only endpoints — identity_id MAY be retained per Requirement 9.8.
 */
Object.defineProperty(exports, "__esModule", { value: true });
